export default __webpack_public_path__ + "static/media/schoology.543c6264.png";